export const API_USERS = {
  FILL_HEALTH_SURVEY: `Users/FillSurvey`,
  CAN_REQUEST_PRESCRIPTION: `Users/CanRequestPrescription`,
  NOTIFY_EMPLOYEE: (taskID: string) => `Users/NotifyEmployees/${taskID}`,
};
